export function getAvailabilityForId(store, id) {
	if (!Array.isArray(store) || !store.find((element) => element.key === id)) {
		return null;
	}

	let record = store.find((element) => element.key === id);

	return {
		status: record.result_status,
		items: record.items
	};
}



// WEBPACK FOOTER //
// ./src/data/OtsSelector.js